<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Changement administrateur</strong>
          </div>
          <b-row>
            <b-col md="12" v-if="formSearch">
              <label><u>Veuillez saisir l'adresse email de l'administrateur actuel</u></label>
              <b-form>
                <b-row class="mb-1">
                  <b-col sm="2">
                    <label for="email"><strong>Email : </strong></label>
                  </b-col>
                  <b-col>
                    <b-form-input
                      id="email"
                      type="text"
                      :class="{hasError: errors.email !== ''}"
                      v-model="email"
                    />
                    <span class="field-error">{{ errors.email }}</span>
                  </b-col>
                  <!-- <b-col>
                    <b-button type="button" @click.prevent="searchAdmin" size="md" style="background-color:#850404d4;color:#ffffff">
                      <i class="fa fa-arrow-right"/> Etape suivante
                    </b-button>
                  </b-col> -->
                </b-row>
                <div class="mt-4" slot="footer">
                  <b-button type="button" @click.prevent="searchAdmin" size="md" class="pull-right" variant="primary">
                    <i class="fa fa-arrow-right"/> Etape suivante
                  </b-button>
                  <!-- <b-button type="button" @click.prevent="cancel" size="md" class="pull-right mr-3" variant="secondary">
                    <i class="fa fa-close"/> Annuler
                  </b-button> -->
                </div>
              </b-form>
            </b-col>
            <b-col md="12" v-if="formEdit">
              <label><u>Veuillez saisir les nouvelles informations de l'administrateur</u></label>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label><strong>Ancien administrateur :</strong></label>
                </b-col>
                <b-col>
                  <label>{{ administrateur.email }}</label><br>
                  <label>{{ civilite }}  {{ administrateur.nom  }}  {{ administrateur.prenom }}</label>
                </b-col>
              </b-row>
              <b-form>
                <label><strong>Nouvel administrateur :</strong></label>
                <b-row class="mb-1">
                  <b-col sm="2">
                    <label for="email"><strong>Email : </strong></label>
                  </b-col>
                  <b-col>
                    <b-form-input
                      id="newEmail"
                      type="text"
                      :class="{hasError: errors.newEmail !== ''}"
                      v-model="newEmail"
                    />
                    <span class="field-error">{{ errors.newEmail }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="2">
                    <label for="civilite"><strong>Civilité : </strong></label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select v-model="selectedCivilite"
                             :options="civiliteOptions"
                             :class="{hasError: errors.selectedCivilite !== ''}">
                      <template #first>
                        <b-form-select-option :value="null" disabled>-- Sélectionner --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <span class="field-error">{{ errors.selectedCivilite }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="2">
                    <label for="nom"><strong>Nom : </strong></label>
                  </b-col>
                  <b-col>
                    <b-form-input
                      id="nom"
                      type="text"
                      :class="{hasError: errors.nom !== ''}"
                      v-model="nom"
                    />
                    <span class="field-error">{{ errors.nom }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-1">
                  <b-col sm="2">
                    <label for="prenom"><strong>Prénom : </strong></label>
                  </b-col>
                  <b-col>
                    <b-form-input
                      id="prenom"
                      type="text"
                      :class="{hasError: errors.prenom !== ''}"
                      v-model="prenom"
                    />
                    <span class="field-error">{{ errors.prenom }}</span>
                  </b-col>
                </b-row>
                <div class="mt-4" slot="footer">
                  <b-button type="button" @click.prevent="saveAdmin" size="md" class="pull-right" variant="primary">
                    <i class="fa fa-save"/> Valider
                  </b-button>
                  <b-button type="button" @click.prevent="cancel" size="md" class="pull-right mr-3" variant="secondary">
                    <i class="fa fa-close"/> Annuler
                  </b-button>
                </div>
              </b-form>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { getAccessToken, getBaseUrl, getIdToken, getProvider } from '../../utils/auth'
  import { isEmpty } from "@/utils/fileHelper"

  export default {
    data() {
      return {
        email: '',
        formSearch: false,
        formEdit: false,
        administrateur: {},
        civilite: '',
        selectedCivilite: null,
        civiliteOptions: [
          {value: 1, text: 'Madame'},
          {value: 2, text: 'Mademoiselle'},
          {value: 3, text: 'Monsieur'}
        ],
        newEmail: '',
        nom: '',
        prenom: '',
        administrateurId: '',
        isEmpty: '',
        errors: {
          email: '',
          newEmail: '',
          selectedCivilite: '',
          nom: '',
          prenom: ''
        }
      }
    },
    mounted() {
      this.formSearch = true
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl()
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common['Accept'] = 'application/json'
      this.$axios.defaults.headers.common['Provider'] = getProvider()
    },
    methods: {
      searchAdmin() {
        if (this.validateMail()) {
          this.$store.commit('IS_LOADING', true)
          let self = this
          let dataPost = {}
          dataPost.email = this.email
          this.$axios
            .post("/espaceEmployeur/inscription-cev/search/admin", dataPost)
            .then(response => {
              this.$store.commit("IS_LOADING", false)
              if (!isEmpty(response.data.administrateur)) {
                this.formSearch = false
                this.formEdit = true
                this.administrateur = response.data.administrateur
                this.administrateurId = this.administrateur.id_utilisateur
                this.civilite = this.administrateur.civilite == 1 ? 'Madame' : this.administrateur.civilite == 2 ? 'Mademoiselle' : 'Monsieur'
                this.errors.email = ''
              } else {
                this.errors.email = "Cette adresse email n'existe pas"
                this.formSearch = true
                this.formEdit = false
              }
            })
            .catch(function (error) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: 'Une erreur est survenue lors de la recherche de l\'administrateur. Si le problème persiste, merci de faire un ticket au support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      saveAdmin() {
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true)
          let dataPost = {}
          dataPost.administrateurId = this.administrateurId
          dataPost.email = this.newEmail
          dataPost.civilite = this.selectedCivilite
          dataPost.nom = this.nom
          dataPost.prenom = this.prenom
          let self = this
          this.$axios
            .post("/espaceEmployeur/inscription-cev/edit/admin", dataPost)
            .then(response => {
              this.$store.commit("IS_LOADING", false)
              if (response.data.result == true) {
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Modification avec succès',
                  text: 'Le changement d\'administrateur a été fait',
                  showConfirmButton: false,
                  timer: 2500
                });
                this.formSearch = true
                this.email = ''
                this.formEdit = false
              }
            })
            .catch(function (error) {
              self.$store.commit("IS_LOADING", false);
              let errorText = 'Une erreur est survenue lors de l\'enregistrement des informations. Si le problème persiste, merci de faire un ticket au support DOSI.'
              if (error.response !== undefined && error.response.status === 424) {
                // console.log(error.response)
                errorText = error.response.data.message;
              }
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: errorText,
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      validateMail() {
        this.clearErrors()
        let valid = true
        let emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
        if (this.email === "") {
          this.errors.email = "L'adresse email est obligatoire"
          valid = false
        } else {
          // JIRA HMESS-288 (supprimer contrôle pour recherche d'un utilisateur existant)
          // if (!emailRegex.test(this.email)) {
          //   this.errors.email = "L'adresse email n'est pas valide"
          //   valid = false
          // }
        }
        return valid;
      },
      validateData() {
        this.clearErrors()
        let valid = true
        if (this.newEmail === "") {
          this.errors.newEmail = "L'adresse email est obligatoire"
          valid = false
        }
        if (this.selectedCivilite === "") {
          this.errors.selectedCivilite = "La civilité est obligatoire"
          valid = false
        }
        if (this.nom === "") {
          this.errors.nom = "Le nom est obligatoire"
          valid = false
        }
        if (this.prenom === "") {
          this.errors.prenom = "Le prénom est obligatoire"
          valid = false
        }
        return valid;
      },
      clearErrors() {
        this.errors.email = ''
        this.errors.newEmail = ''
        this.errors.civilite = ''
        this.errors.nom = ''
        this.errors.prenom = ''
      },
      cancel() {
        // this.$router.push({ path: '/espace-employeur/inscription-cev' })
        this.formSearch = true
        this.formEdit = false
        this.email = ''
      }
    }
}
</script>

<style>
</style>
